<template>
  <router-view />
  <notifications />
</template>

<style lang="scss">
// Import Main styles for this application
@import 'styles/style';
</style>
